import React from 'react'
import styled from '@emotion/styled'
import ToolCard from 'components/ToolCard'
import { array, string } from 'prop-types'

//styled components
const SectionWrapper = styled.div`
	background: ${({ theme }) => theme.colors.tertiary};
	color: #fff;
	height: 100%;
	position: relative;
	width: 100%;
`
const TitleWrapper = styled.div`
	font-size: 21px;
	padding: 40px 40px 0 40px;

	${({ theme }) => theme.MQ.M} {
		font-size: 34px;
		font-weight: 500;
		padding-top: 80px;
		text-align: center;
	}
`
const ToolsWrapper = styled.div`
	display: flex;
	flex-direction: column;

	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		margin: auto;
		max-width: 1200px;
		padding: 20px 40px 40px;
	}
`
AdditionalTools.propTypes = {
	title: string.isRequired,
	tools: array.isRequired,
	relatedArticles: array.isRequired,
}

/**
 * This is the additional tools section for the review landing page
 */
function AdditionalTools({ title, tools, relatedArticles }) {
	// Currently, Community and Articles are coming in the array of tools.
	// We are deprecating Community and so we filter out only articles here.
	const articles = tools.filter((item) => item.title === 'Articles')
	return (
		<SectionWrapper>
			<TitleWrapper>{title}</TitleWrapper>
			<ToolsWrapper>
				{articles.map((toolDetails, i) => {
					return <ToolCard {...toolDetails} displayBorder={false} feed={relatedArticles} key={i} />
				})}
			</ToolsWrapper>
		</SectionWrapper>
	)
}
export default AdditionalTools
